import { article_path, newsletter_article_path } from '@routes';

import { parameterize } from './formatting';

export const buildQueryString = (params: Record<string, unknown>): string => {
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      searchParams.append(key, String(value));
    }
  }

  return searchParams.toString();
};

export const extractQueryParams = (paramsToExtract: string[]): Record<string, string | null> => {
  const queryParams = new URLSearchParams(window.location.search);
  const result: Record<string, string | null> = {};

  paramsToExtract.forEach((paramName) => {
    result[paramName] = queryParams.get(paramName);
  });

  return result;
};

export const addParamToUrl = (url: string, key: string, value: string): string => {
  const urlString = String(url);
  const urlWithProtocol =
    urlString.startsWith('http://') || urlString.startsWith('https://')
      ? urlString
      : `${window.location.origin}${urlString.startsWith('/') ? '' : '/'}${urlString}`;

  const urlObj = new URL(urlWithProtocol);
  urlObj.searchParams.set(key, value);
  return urlObj.toString();
};

export type UtmParams = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
};

export const articlePathWithParams = ({
  slug,
  utm = {},
  offer,
  newsletterSlug,
}: {
  slug: string;
  utm?: UtmParams;
  offer?: string;
  newsletterSlug?: string;
}) => {
  const basePath = newsletterSlug
    ? newsletter_article_path({ name: newsletterSlug, slug: slug })
    : article_path(slug);
  const url = new URL(basePath, window.location.origin);

  if (offer) {
    url.searchParams.set('offer', offer);
  }

  for (const [key, value] of Object.entries(utm)) {
    if (value) {
      url.searchParams.set(key, value);
    }
  }

  return url.pathname + url.search;
};

export const articlePath = ({
  slug,
  newsletterSlug,
}: {
  slug: string;
  newsletterSlug?: string;
}) => {
  return newsletterSlug
    ? newsletter_article_path({ name: newsletterSlug, slug: slug })
    : article_path(slug);
};
